import { action } from 'satcheljs';

export default action('ON_BPOS_NAV_BAR_DATA_LOADED');
